import { render, staticRenderFns } from "./incident-banner.vue?vue&type=template&id=a4d79640&scoped=true&"
import script from "./incident-banner.vue?vue&type=script&lang=js&"
export * from "./incident-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d79640",
  null
  
)

export default component.exports